import { render, staticRenderFns } from "./gelbschale-rueckmeldung.vue?vue&type=template&id=d4922e08&scoped=true&"
import script from "./gelbschale-rueckmeldung.vue?vue&type=script&lang=js&"
export * from "./gelbschale-rueckmeldung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4922e08",
  null
  
)

export default component.exports